import { cn } from '@utils/cn';

import type {
  TableBodyProps,
  TableCellProps,
  TableHeaderProps,
  TableHeadProps,
  TableProps,
  TableRowProps
} from './Table.types';

import {
  tableCellClasses,
  tableClasses,
  tableHeadClasses,
  tableHeaderClasses,
  tableRowClasses,
  tableWrapperClasses
} from './Table.styles';

export const Table = ({ className, children, ...props }: TableProps) => {
  return (
    <div className={cn(tableWrapperClasses())}>
      <table className={cn(tableClasses(), className)} {...props}>
        {children}
      </table>
    </div>
  );
};

const TableHeader = ({ className, children, ...props }: TableHeaderProps) => {
  return (
    <thead className={cn(tableHeaderClasses(), className)} {...props}>
      {children}
    </thead>
  );
};

const TableHead = ({ className, children, ...props }: TableHeadProps) => {
  return (
    <th className={cn(tableHeadClasses(), className)} {...props}>
      {children}
    </th>
  );
};

const TableBody = ({ className, children, ...props }: TableBodyProps) => {
  return (
    <tbody className={cn(className)} {...props}>
      {children}
    </tbody>
  );
};

const TableRow = ({ className, children, onClick, ...props }: TableRowProps) => {
  return (
    <tr
      className={cn(tableRowClasses({ onClick: Boolean(onClick) }), className)}
      onClick={onClick}
      {...props}
    >
      {children}
    </tr>
  );
};

const TableCell = ({ className, children, ...props }: TableCellProps) => {
  return (
    <td className={cn(tableCellClasses(), className)} {...props}>
      {children}
    </td>
  );
};

Table.Header = TableHeader;
Table.Head = TableHead;
Table.Body = TableBody;
Table.Row = TableRow;
Table.Cell = TableCell;

export default Table;
